export enum InterviewTypeEnum {
    Audio = 1,
    Video = 2,
    CodeTest = 3
}